import { getI18n } from 'react-i18next';

export const VALIDATION_CLIENT_APPLICATION_ID_ALREADY_IN_USE = 'validation.clientApplication.applicationIdAlreadyInUse';
export const VALIDATION_CLIENT_APPLICATION_EMPTY_APPLICATION_ID = 'validation.clientApplication.emptyApplicationId';
export const VALIDATION_CLIENT_APPLICATION_INVALID_APPLICATION_ID_LENGTH = 'validation.clientApplication.invalidApplicationIdLength';
export const VALIDATION_CLIENT_APPLICATION_INVALID_DESCRIPTION_LENGTH = 'validation.clientApplication.invalidDescriptionLength';
export const VALIDATION_CLIENT_APPLICATION_EMPTY_ACTIVE = 'validation.clientApplication.emptyActive';
export const ERROR_CLIENT_APPLICATION_NOT_FOUND = 'clientApplication.notFound';
export const ERROR_CLIENT_APPLICATIONS_AMQP_DISABLED = 'clientApplications.amqpDisabled';

export const createClientApplicationErrorMessage = (code, params) => { // NOSONAR javascript:S3800
    let result;
    const i18n = getI18n();
    switch (code) {
        case VALIDATION_CLIENT_APPLICATION_ID_ALREADY_IN_USE:
            result = i18n.t('settings.client-applications.error.client-application-id-already-in-use', { applicationId: params[0] });
            break;
        case VALIDATION_CLIENT_APPLICATION_EMPTY_APPLICATION_ID:
            result = i18n.t('settings.client-applications.error.client-application-empty-application-id');
            break;
        case VALIDATION_CLIENT_APPLICATION_INVALID_APPLICATION_ID_LENGTH:
            result = i18n.t('settings.client-applications.error.client-application-invalid-application-id-length', { maxLetters: params[0] });
            break;
        case VALIDATION_CLIENT_APPLICATION_INVALID_DESCRIPTION_LENGTH:
            result = i18n.t('settings.client-applications.error.client-application-invalid-description-length', { maxLetters: params[0] });
            break;
        case VALIDATION_CLIENT_APPLICATION_EMPTY_ACTIVE:
            result = i18n.t('settings.client-applications.error.client-application-empty-active');
            break;
        case ERROR_CLIENT_APPLICATION_NOT_FOUND:
            result = i18n.t('settings.client-applications.error.client-application-not-found');
            break;
        case ERROR_CLIENT_APPLICATIONS_AMQP_DISABLED:
            result = i18n.t('settings.client-applications.error.client-applications-amqp-disabled');
            break;
        default:
            result = undefined;
    }
    return result;
};
